import React, { useEffect, useState } from 'react';

import {
  Button,
  CircularProgress,
  FormControl,
  FormControlLabel,
  FormLabel,
  IconButton,
  InputLabel,
  MenuItem,
  Modal,
  Radio,
  RadioGroup,
  Select,
  TextField,
  Typography,
} from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';

import Autocomplete from '@material-ui/lab/Autocomplete';
import _ from 'lodash';
import stylesMaterial from './stylesMaterial';
import { Container, Header } from './styles';
import { useToast } from '../../../../../hooks/toast';
import IfoodService, { ICancelReason, IIntegration } from '../../../../../services/IfoodService';

interface CancelOrderModalProps {
  open: boolean;
  handleClose: () => void;
  loadPedidoData: () => {};
  orderId: string;
  companyId: number;
}

export function CancelOrderModal({
  open,
  handleClose,
  loadPedidoData,
  orderId,
  companyId,
}: CancelOrderModalProps) {
  const classes = stylesMaterial();

  const { addToast } = useToast();

  const [cancelReasonsOptions, setCancelReasonsOptions] = useState<ICancelReason[]>([])
  const [selectedReason, setSelectedReason] = useState<ICancelReason | null>(null);
  const [isOptionsLoading, setIsOptionsLoading] = useState(false);
  const [isCancelLoading, setIsCancelLoading] = useState(false);
  const [clientInfo, setClientInfo] = useState<IIntegration | null>(null);

  useEffect(() => {
    setIsOptionsLoading(true);
    IfoodService.getClientInfo(companyId).then((res) => {
      setClientInfo(res);

      IfoodService.getCancelReasons(orderId, companyId, res.key || '').then((response) => {
        setCancelReasonsOptions(response);
        setIsOptionsLoading(false);
      }).catch((error) => {
        console.log(error);
      });
    }).catch((error) => {
      console.log(error);
    })
  }, []);

  function handleCancelOrder() {
    if(clientInfo && selectedReason) {
      setIsCancelLoading(true);

      IfoodService.cancelOrder(
        orderId, 
        companyId, 
        selectedReason.description, 
        selectedReason.cancelCodeId, 
        clientInfo.key || ''
      ).then((res) => {
        addToast({
          type: 'success',
          title: 'Pedido cancelado. Logo o pedido será atualizado.'
        });

        handleClose();
      }).catch((error) => {
        console.log(error);
        addToast({
          type: 'error',
          title: 'Erro no cancelamento'
        });
      })
    }
  }

  return (
    <Modal
      open={open}
      onClose={handleClose}
      aria-labelledby="insert-in-cart-options-modal"
      aria-describedby="insert-in-cart-options-balance"
      className={classes.modal}
    >
      <Container>
        <Header>
          <IconButton
            aria-label="close"
            onClick={handleClose}
            className={classes.buttonClose}
          >
            <CloseIcon className={classes.iconClose} />
          </IconButton>
        </Header>

        <FormControl className={classes.formControl}>
          <Autocomplete
            id="combo-box-agencies"
            options={cancelReasonsOptions}
            getOptionLabel={(option) => option.description}
            value={selectedReason}
            onChange={(event: any, newValue: ICancelReason | null) => {
              if (newValue !== null) {
                setSelectedReason(newValue);
              }
            }}
            getOptionSelected={(option, value) => _.isEqual(option, value)}
            renderInput={(params) => (
              <TextField
                {...params}
                name="cancel-reason"
                type="cancel-reason"
                label="Razão para cancelamento"
                variant="outlined"
              />
            )}
            noOptionsText={'Selecione uma razão'}
            loading={isOptionsLoading}
            loadingText='Carregando...'
          />

          <Button
            disabled={isCancelLoading || isOptionsLoading}
            onClick={handleCancelOrder}
            className={classes.button}
          >
            {isCancelLoading ? <CircularProgress /> : 'Concluir'}
          </Button>
        </FormControl>
      </Container>
    </Modal>
  );
}
